export default {
  title: 'Explore by PONANT',
  pickers: {
    ships: 'Choose ship',
    regions: 'Choose region',
    search: 'Find a stopover',
    empty: "Sorry, we can't find a match among our cruise stopovers.",
    stopover: 'Stopover',
  },
  cruising: 'Cruising',
  modal: {
    webcam: "See ship's webcam",
    visit: "Discover ship's virtual tour",
    showCruise: 'Show on map',
    more: 'Learn more',
    cruiseSeparator: 'The next cruise',
    realTimeCheck: "Ship's live webcam",
    video: 'Discover the ship on video',
  },
  ship: {
    more: 'More about {{name}}',
    allCruises: "All ship's cruises",
    return: 'Go back',
    nextCruise: 'The next cruise',
    nextCruiseMulti: 'Next cruises',
  },
  stopover: {
    nextCruise: 'Next cruise through this stop',
    nextCruiseMulti: 'Next cruises through this stop',
    allCruises: 'All cruises through this stop',
    panoramas: 'Discover in the area',
  },
  cruise: {
    quit: 'Leave this cruise',
    from: 'From',
    to: 'to',
    discover: 'Discover the cruise stopovers by clicking on them and learn more about every stops',
    begin: 'Begin',
    close: 'Leave this cruise',
    noImage: 'Image unavailable',
  },
  close: 'Close',
  showMore: 'Show more',
  regions: {
    alaska: 'Alaska',
    arctic: 'The Arctic',
    northAmerica: 'North America & Canada',
    northEurope: 'Northern Europe & Scandinavia',
    mediterranea: 'The Mediterranean',
    asia: 'Asia',
    redSea: 'Red Sea',
    caribbean: 'Caribbean',
    centralAmerica: 'Central America',
    southAmerica: 'South America',
    africa: 'Africa & Indian Ocean',
    atlantic: 'Atlantic Coast',
    oceania: 'Oceania & Pacific Islands',
    antarctic: 'Antarctica',
  },
  branding: {
    body: 'Enjoy an immersive experience and discover our destinations as if you were actually there!',
    action: 'Start',
  },
}
